import React, { useState } from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { Heading, Text, WYSIWYG, NotationBlock } from '../../util/typography';
import ComponentWrapper from '../layout/ComponentWrapper';
import { componentTheme } from '../../util/functions';
import { createMarkup } from '../../util/functions';
import { TertiaryButton } from '../../util/CTA';
import { StyledTertiaryButton } from '../EarlierStageGrid';

const StyledBreakoutContentRow = styled.div`
    /* magic numbers */
    /* --sectionContainerMaxWidth: 992px; */
    --gridSpacing: 20px;
    /* --childFlexBasis: calc((var(--sectionContainerMaxWidth) / 2) - (2 * var(--gridSpacing))); */
    --iconSize: 60px;
    --iconPadding: 16px;
    --iconContainer: calc(var(--iconSize) + ((var(--iconPadding) + 1px) * 2));
    --halfIconContainer: calc(var(--iconContainer) / 2);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 calc((var(--gridSpacing) / 2) * -1) calc(var(--gridSpacing) * -1);

    & > * {
        flex-basis: calc(50%- (2 * var(--gridSpacing)));
        flex-shrink: 1;
        flex-grow: 1;
        /* sibling horizontal spacing handled in the row */
        margin-left: calc(var(--gridSpacing) / 2);
        margin-right: calc(var(--gridSpacing) / 2);
        min-width: 280px;
    }
`;

const BreakoutContentRow = props => {
    const theme = componentTheme(true, props.sectionTheme, props.theme);
    return (
        <ComponentWrapper>
            <StyledBreakoutContentRow>{props.children}</StyledBreakoutContentRow>
            {(props.footnotes || props.definitions) && <NotationBlock footnotes={props.footnotes} definitions={props.definitions} theme={theme} />}
        </ComponentWrapper>
    )
};

const StyledCard = styled.div`
    position: relative;
    ${(props) => props.isQsub ?
        `
        display: flex;
        flex-direction: column;
        `:
        ``}
    width: 100%;
    // padding: ${(props) => props.isQsub ? "68px 0 30px" : "68px 20px 30px"};
    padding:  ${(props) => props.isQsub ? props.isIcon ? "calc(var(--halfIconContainer) + var(--gridSpacing)) 0 0": "0" : "calc(var(--halfIconContainer) + var(--gridSpacing)) var(--gridSpacing) 30px"};
    border-radius: 8px;
    /* vertical margin handled in card */
    margin-top: var(--halfIconContainer);
    margin-bottom: var(--gridSpacing);
    flex: 1 1 calc(33.33% - (var(--gridSpacing) * 2));
    ${({ minWidth }) => minWidth || '280px'};
    flex-basis: ${({ columns }) => columns ? 'calc(33.33% - (var(--gridSpacing) * 2))' : 'calc(50% - (var(--gridSpacing) * 2))'};
    transition: 0.3s ease; 
    cursor: ${({isClickable})=> isClickable ?  'pointer': 'default'};
    max-width: ${({card}) => card === 'earlyStage' ? '317px' : '100%'};
    // max-width: 317px;



    ${({cardType}) => cardType === 'lightPurple' ?
    `background-color: ${colors.extraLightPurple}; 
     border: 1px solid ${colors.pebble};
        `
    : cardType === 'green' ?
    `
        background: ${colors.linearGradientGreen}; 
        border: 1px solid ${colors.keytrudaGreenWeb};
    `  
    : cardType === 'purple' ? 
    `
        background: ${colors.linearGradientPurple};
        border: 1px solid ${colors.darkPurple};
    ` 
    : `
     background-color:${colors.white};
     border: 1px solid ${colors.pebble};
    `}

    &:hover {
    ${StyledTertiaryButton} {
        span {
            color: ${({isClickable}) => isClickable && colors.blueberryDark} !important;
        }
      }
    }

    @media (max-width: 571px) and (min-width: 320px ) {
        max-width: 100%;
    }
`;

const IconWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: var(--iconContainer);
    height: var(--iconContainer);
    border: 1px solid ${colors.pebble};
    border-radius: 50%;
    background-color: white;
    padding: var(--iconPadding);
    transition: 0.3s ease;        

    & > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    // &:hover {
    //     border-color:${({ isClickable }) => isClickable ? colors.white : ''};
    //     box-shadow: ${({ isClickable }) => isClickable ? '0 4px 20px 0 rgba(0, 0, 0, 0.16)' : ''};
    //     }
`;

const CardContent = styled(WYSIWYG)`
    max-width: 824px;
    margin: auto;
    height: 100%;
`;

const BreakoutCardHeader = styled(Heading.H6)`
    text-align: ${({ shouldCenter }) => (shouldCenter ? 'center' : 'left')};
`;

const BreakoutCardText = styled(Text.Body)`
    display: ${({ card }) => (card === 'earlyStage' ? 'flex' : 'block')};
    flex-direction: ${({ card }) => (card === 'earlyStage' && 'column')};
    justify-content: ${({ card }) => (card === 'earlyStage' && 'space-between')};
    height: 100%;

    * + & {
        margin-top: 16px;
    }
`;

const QsubHeading = styled(Heading.H4)`
padding: 0 20px 20px;
border-bottom: 1px solid ${colors.pebble};
text-align:center;
`
const QsubHeadingNoIcon = styled(Heading.H7)`
padding: 16px 20px;
text-align:center;
display: flex;
align-items: center;
justify-content: center;
font-weight: 400;


${({cardType}) => cardType === 'lightPurple' ?
    `border-bottom: 1px solid ${colors.pebble}; 
        `
    : cardType === 'green' ?
    `
        border-bottom: 1px solid ${colors.keytrudaGreenWeb};
        color: ${colors.white};
    `  
    : cardType === 'purple' ? `
        border-bottom: 1px solid ${colors.darkPurple};
        color: ${colors.white};
    ` 
    : ``}

@media (min-width: 768px) {
 min-height: ${({cardType}) => cardType === 'lightPurple' && '80px' };
 font-weight: 500;
  }
`

const QsubContent = styled.div`
background: ${colors.white};
padding: 10px 20px 20px;
display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: space-between;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
`
const Button = styled(TertiaryButton)`
`;

const LinkContainer = styled.div`
    // ${props => !props.verticalCenter && `margin-top: auto;`}
    pointer-events: none;
    background:${colors.white};
    @media (max-width: 768px) {
        width: 100%;
        align-items: stretch;
    }
`;

export const BreakoutContentCard = ({ icon, title, children, columns, card, isClickable, url, isQsub = false, qsubTitle, buttonLabel, buttonProps, headColor, cardType, linkButton, setisEarlyCardHovered }) => {
    const hasBodyText = !!children;
    const [isCardHovered, setIsCardHovered] = useState(false);
    const onCardMouseEnter = () => {
        setIsCardHovered(true); 
        if(card ==='indicationCallout'){
         setisEarlyCardHovered(true) 
        }
             
    };

    const onCardMouseLeave = () => {
        setIsCardHovered(false);
        if(card ==='indicationCallout'){
         setisEarlyCardHovered(false);                   
        }
    
    };

    const handleClick = (url) => {
        window.location.href = url;
    }
    

    return (
        <StyledCard columns={columns} isQsub={isQsub} onMouseEnter={()=>onCardMouseEnter()} onMouseLeave={()=>onCardMouseLeave()} isClickable={isClickable} onClick={() => isClickable ? handleClick(url) : undefined} isIcon={icon} cardType={cardType} card={card}
        >
            {icon && (
                <IconWrapper isClickable={isClickable}>
                    {typeof icon === 'function' && icon()}
                </IconWrapper>
            )}
            {title && (
                <BreakoutCardHeader as='H3' $shouldCenter={!hasBodyText} dangerouslySetInnerHTML={createMarkup(title)} />
            )}
            {qsubTitle && (
                icon ?
                <QsubHeading $shouldCenter={true} dangerouslySetInnerHTML={createMarkup(qsubTitle)} />
                :
                <QsubHeadingNoIcon $shouldCenter={true} dangerouslySetInnerHTML={createMarkup(qsubTitle)} cardType={cardType} />
            )}
            {
                isQsub ?
                    <QsubContent url={url}>
                        {children}
                        {
                            url &&
                            <LinkContainer >
                                <Button
                                    forwardedAs="span"
                                    label={buttonLabel}
                                    url={url}
                                    parentHovered={isCardHovered}
                                    {...buttonProps}
                                />
                            </LinkContainer>
                        }
                    </QsubContent>

                    :
                    <>
                        <CardContent>
                            {hasBodyText && <BreakoutCardText card={card} >{children}</BreakoutCardText>}
                        </CardContent>
                         {
                           ( url && linkButton) &&
                            <LinkContainer>
                                <Button
                                    forwardedAs="span"
                                    label={buttonLabel}
                                    url={url}
                                    parentHovered={isCardHovered}
                                    {...buttonProps}
                                />
                            </LinkContainer>
                        } 
                    </>
            }


        </StyledCard>
    );
};

export default BreakoutContentCard;
export { BreakoutContentRow };
